import React from "react";
import { useHotkeys } from "react-hotkeys-hook";

import { Select } from "antd";
import { useMapStore } from "stores/map";
import styled from "styled-components";

import { UwidFormatT, useWellList } from "components/well-list/context";
import { updateSettingUwiFormat } from "components/well-list/context/reducer";
import * as hooks from "components/well-list/hooks";

import { useMidstreamNavigatorContext } from "../context/MidstreamNavigatorContext";

const EntitySelector: React.FC = () => {
  const [midstreamState] = useMidstreamNavigatorContext();
  const [wellListState, wellListDispatch] = useWellList();

  hooks.useSelectedEntitiesFromStore(midstreamState.mode);
  const setSelectedEntities = useMapStore((s) => s.setSelectedEntities);

  const selectedWell = wellListState?.selectedWell;
  const wells = wellListState?.wells;
  const settings = wellListState?.settings;

  const handleUwiFormatChange = (value: UwidFormatT) => {
    updateSettingUwiFormat(wellListDispatch, value);
  };

  // TODO: Need to handle the Facility side to have it display facility name - EVA-3351
  useHotkeys(
    "u",
    () => {
      handleUwiFormatChange(settings?.uwidFormat === "uwid" ? "entityName" : "uwid");
    },
    [handleUwiFormatChange, settings?.uwidFormat]
  );

  const updateSelectedWell = (uwid: string) => {
    if (uwid) {
      const obj = {};
      obj[uwid] = { Uwi: uwid };
      setSelectedEntities(wellListState.entityKind, obj);
    }
  };

  // Use the same formatting logic as WellSelector for consistent display
  const displayValue = selectedWell
    ? settings?.uwidFormat === "entityName"
      ? selectedWell?.FormattedUwi
      : selectedWell?.Uwi
    : undefined;

  return (
    <InputWrapper>
      <SelectWrapper
        data-testid="entity-selector"
        showSearch
        placeholder={`No ${midstreamState.mode} Selected`}
        popupClassName="modal-fixed-font-width"
        value={displayValue}
        onChange={updateSelectedWell}
        filterOption={(inputValue, option) => {
          if (inputValue && option) {
            return (
              option.entityName?.toLowerCase()?.includes(inputValue.toLowerCase()) ||
              option.uwid?.toLowerCase()?.includes(inputValue.toLowerCase())
            );
          }
          return true;
        }}
        options={wells.map((well) => {
          return {
            key: well?.id,
            label: settings?.uwidFormat === "uwid" ? well?.id : well?.label,
            entityName: well?.label,
            uwid: well.id,
            value: well?.id
          };
        })}
      />
    </InputWrapper>
  );
};

const SelectWrapper = styled(Select)`
  font-family: var(--fontMono);
  width: 100%;

  div {
    border-radius: 6px !important;
  }
`;

const InputWrapper = styled.div`
  max-width: 100%;
  flex-grow: 1;
`;

export default EntitySelector;
